<template>
  <div class="settings-container">
    <div class="settings-item">
      <div class="label">Registration Confirmation Email</div>
      <el-switch v-model="form.emailsEnabled"> </el-switch>
    </div>
    <div class="settings-item">
      <div class="label">Email Title</div>
      <el-input v-model="form.regConfirmationTitle"></el-input>
    </div>
    <div class="settings-item">
      <div class="label">Email Content</div>
      <vue-editor
        id="editor"
        useCustomImageHandler
        @image-added="handleImageAdded"
        v-model="form.regConfirmationContent"
      ></vue-editor>
    </div>
    <div class="settings-item">
      <el-button type="primary" v-on:click="save" style="margin-bottom: 1rem"
        >Save</el-button
      >
    </div>
  </div>
</template>

<script>
/* eslint-disable import/order */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */

import { VueEditor } from 'vue2-editor';
import * as fb from '@/firebase';
import { mapGetters } from 'vuex';

export default {
  components: { VueEditor },
  computed: {
    ...mapGetters({
      currentEvent: 'event/current',
    }),
  },
  async created() {
    try {
      const eventId = this.currentEvent.id;
      const registrationSettingsSnap = await fb.db
        .doc(`event/${eventId}/settings/registrationSettings`)
        .get();
      const registrationSettings = registrationSettingsSnap.data();

      Object.assign(this.form, {
        emailsEnabled: registrationSettings.emailsEnabled
          ? registrationSettings.emailsEnabled
          : false,
        ...(registrationSettings.regConfirmationTitle
          ? { regConfirmationTitle: registrationSettings.regConfirmationTitle }
          : null),
        ...(registrationSettings.regConfirmationContent
          ? {
              regConfirmationContent:
                registrationSettings.regConfirmationContent,
            }
          : null),
      });
    } catch (error) {
      console.log(error);
    }
  },
  data() {
    return {
      form: {
        emailsEnabled: false,
        regConfirmationTitle: 'Etkinlik Kayıt Onayı',
        regConfirmationContent:
          '<h1>Webcast Kayıt Onayı</h1> <br> <p>Sayın {{name}}</p> <p>{{event-title}} etkinliğimize aşağıdaki linkten ulaşabilirsiniz <p>Webcast giriş linki: {{event-url}}</p> <p><br></p> <p>NOT: Size iletilen bu link kişiye özeldir. Lütfen başka kimse ile paylaşmayınız</p>',
      },
    };
  },
  methods: {
    async save() {
      try {
        const eventId = this.currentEvent.id;
        const registrationSettingsSnap = await fb.db
          .doc(`event/${eventId}/settings/registrationSettings`)
          .get();

        if (registrationSettingsSnap.exists) {
          await fb.db
            .doc(`event/${eventId}/settings/registrationSettings`)
            .update({
              ...this.form,
              updatedAt: fb.timestamp(),
            });
        } else {
          await fb.db
            .doc(`event/${eventId}/settings/registrationSettings`)
            .set({
              ...this.form,
              createdAt: fb.timestamp(),
            });
        }

        this.$notify({
          title: 'Success',
          message: 'Settings Saved Successfully',
          type: 'success',
        });
      } catch (error) {
        console.log(error);
        this.$notify.error({
          title: 'Error',
          message: 'An Error Occurred While Saving Settings',
        });
      }
    },
    async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      try {
        const storageRef = fb
          .storage()
          .ref()
          .child(`/${this.currentEvent.id}/${file.name}`);
        const picSnap = await storageRef.put(file);
        const picUrl = await picSnap.ref.getDownloadURL();

        Editor.insertEmbed(cursorLocation, 'image', picUrl);
        resetUploader();
      } catch (error) {
        console.log(error);

        this.$notify.error({
          title: 'Error',
          message: 'An Error Occurred While Uploading Image',
        });
      }
    },
  },
};
</script>

<style>
.settings-item {
  margin-bottom: 1rem;
}

.label {
  margin-bottom: 1rem;
}
</style>
